import { AsyncComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getSupplierDetails, getSuppliers, type GetSuppliersParams } from '../../api/clients/company.api';
import { queries } from '../../api/queryKeys/queries';
import { formatCompanyName } from '../../helpers/formatCompanyName.helper';
import type { AsyncSingleSelectProps } from '../AsyncSelectProps';

export interface SupplierCompanySelectProps extends AsyncSingleSelectProps {
    onChange: (supplierId: string) => void;
    groupId?: string;
    value: string;
}

const loadSuppliers = async (params: GetSuppliersParams): Promise<ComboBoxOption[]> => {
    const suppliers = await getSuppliers(params);

    return suppliers.map((company) => ({
        value: company.id,
        label: formatCompanyName({
            company,
        }) as ComboBoxOption['label'],
    }));
};

const loadSupplier = async (supplierId: string): Promise<ComboBoxOption | null> => {
    const company = await getSupplierDetails(supplierId);

    return {
        value: company.id,
        label: formatCompanyName({
            company,
        }) as ComboBoxOption['label'],
    };
};

export function SupplierCompanySelect({ groupId, value, onChange, ...rest }: SupplierCompanySelectProps) {
    return (
        <AsyncComboBox
            {...rest}
            value={value || null}
            onChange={(nextValue) => onChange(nextValue ?? '')}
            optionsQueryKey={(search) => queries.suppliers.comboBoxOptions({ searchQuery: search, groupId }).queryKey}
            optionsQueryFn={(search) => loadSuppliers({ searchQuery: search, groupId })}
            selectedOptionQueryKey={(selectedValue) => queries.suppliers.selectedComboBoxOption(selectedValue).queryKey}
            selectedOptionQueryFn={loadSupplier}
        />
    );
}
